/* KC Custom Scripts */
(function() {
  var header = document.querySelector('#shopify-section-header header') || document.querySelector('header.header');
  if (!header) return;
  
  var scrollThreshold = 50;
  
  function onScroll() {
    if (window.scrollY > scrollThreshold) {
      header.classList.add('kc-header-scrolled');
    } else {
      header.classList.remove('kc-header-scrolled');
    }
  }
  
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once on load
})();